import React from 'react';
import { Container, Image } from 'react-bootstrap';
import Slider from 'react-slick';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { BsArrowRight, BsArrowLeft } from "react-icons/bs";
import { ImageUrl } from '../../../../../Helpers/request';

const BestSellingProduct = () => {
    const data = [
        { title: "14K White Gold Solitaire Marquise Shape Diamond Engagement Ring", url: "/ringsettingdetail/setting/14k-white-gold--marquise-engagement-rings-570193", image: `${ImageUrl}theme/paris/ring-style/F1622.jpg` },
        { title: "14K White Gold Solitaire Pear Shape Diamond Engagement Ring", url: "/ringsettingdetail/setting/14k-white-gold--pear-engagement-rings-570194", image: `${ImageUrl}theme/paris/ring-style/F1623.jpg` },
        { title: "14K White Gold Solitaire Cushion Shape Diamond Engagement Ring", url: "/ringsettingdetail/setting/14k-white-gold--cushion-engagement-rings-570192", image: `${ImageUrl}theme/paris/ring-style/F1624.jpg` },
        { title: "14K White Gold Solitaire Princess Shape Diamond Engagement Ring", url: "/ringsettingdetail/setting/14k-white-gold--princess-engagement-rings-570189", image: `${ImageUrl}theme/paris/ring-style/F1625.jpg` },
        { title: "14K White Gold Solitaire Emerald Shape Diamond Engagement Ring", url: "/ringsettingdetail/setting/14k-white-gold--emerald-engagement-rings-570190", image: `${ImageUrl}theme/paris/ring-style/F1626.jpg` },
        { title: "14K White Gold Solitaire Oval Shape Diamond Engagement Ring", url: "/ringsettingdetail/setting/14k-white-gold--oval-engagement-rings-570191", image: `${ImageUrl}theme/paris/ring-style/F1627.jpg` },
    ]

    let settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrow: true,
        prevArrow: <button aria-label="arrow"><BsArrowLeft /></button>,
        nextArrow: <button aria-label="arrow"><BsArrowRight /></button>,
        responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
            },
        },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
        beforeChange: (current, next) => {
            document
              .querySelectorAll('.slick-slide[aria-hidden="true"] a, .slick-slide[aria-hidden="true"] button, .slick-slide[aria-hidden="true"] input')
              .forEach(el => el.setAttribute('tabindex', '-1'));
          },
          afterChange: () => {
            document
              .querySelectorAll('.slick-slide:not([aria-hidden="true"]) a, .slick-slide:not([aria-hidden="true"]) button, .slick-slide:not([aria-hidden="true"]) input')
              .forEach(el => el.removeAttribute('tabindex'));
          }
    };

  return (
    <div className='product-bestsale-jewelry hidden-xs'>
        <Container>
            <div className="main_heading">
                <h2> Best Selling Products </h2>
            </div>
            
            <div className='box-best-seller9'>
                <Slider {...settings}>
                    {
                        data.map((item, index) => <Item key={index} title={item.title} url={item.url} image={item.image} />)   
                    }
                </Slider>

                <div className='ser_btn_sec text-center mt-4'>
                    <Link to='/jewelry' className="btn ser_btn">Shop Engagement Ring</Link>
                </div>
            </div>
        </Container>
    </div>
  )
}

const Item = ({ title, url, image }) => {
    return (
        <div className='pb_inner item-product'>
            <Link to={url}>
                <div className='product-thumb'>
                    <Image src={image} alt='product' />
                </div>

                <div className='product-info'>
                    <h3 className="title14 product-title">{title}</h3>
                    <div className="product-price">
                        <span>$360</span>
                        <del className="silver">360</del>
                    </div>
                </div>
            </Link>
        </div>
    )
}

export default BestSellingProduct